import React from 'react';

const SouthernLivingModal = ({
  isOpen,
  onClose,
  title,
  description,
  mobileDescription,
  images = [],
  cta,
  variant = '',
  qa = [],
  avatar,
  name,
  titleLine,
}) => {
  if (!isOpen) return null;

  const isTestimonial = variant === 'testimonial';

  return (
    <div className="sl-modal-backdrop" onClick={onClose}>
      <div
        className={`sl-modal-content ${variant ? `sl-modal--${variant}` : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="sl-modal-close" onClick={onClose}>
          &times;
        </button>

        <h2>{title}</h2>

        {/* SL Testimonial Modal */}
        {isTestimonial && (
          <>

            <div className="sl-modal__qa-flex">
              {/* Left column */}
              <div className="sl-modal__qa-col">
                {avatar && (
                  <div className="sl-modal__avatar-block">
                    <img className="sl-modal__avatar" src={avatar} alt={name} loading="lazy"/>
                    <div>
                      <div className="sl-modal__name">{name}</div>
                      <div className="sl-modal__title">2025 Southern Living Idea House</div>
                      <div className="sl-modal__title" style={{ fontStyle: 'italic' }}>
                        {titleLine}
                      </div>
                    </div>
                  </div>
                )}
                {qa?.[0] && (
                  <div className="sl-modal__qa">
                    <div className="sl-modal__question">{qa[0].question}</div>
                    <div className="sl-modal__answer">{qa[0].answer}</div>
                  </div>
                )}
                {qa?.[1] && (
                  <div className="sl-modal__qa">
                    <div className="sl-modal__question">{qa[1].question}</div>
                    <div className="sl-modal__answer">{qa[1].answer}</div>
                  </div>
                )}
              </div>

              {/* Right column */}
              <div className="sl-modal__qa-col">
                {qa?.slice(2).map((item, index) => (
                  <div className="sl-modal__qa" key={index + 2}>
                    <div className="sl-modal__question">{item.question}</div>
                    <div className="sl-modal__answer">{item.answer}</div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        {/* SL Cards Modal */}
        {!isTestimonial && images.length > 0 && (
          <>
            <p className='description__desktop'>{description}</p>
            <p className='description__mobile'>{mobileDescription}</p>
            <div className="sl-modal-gallery">
              {images.map((src, i) => (
                <img key={i} src={src} alt={`Modal image of propane product ${i + 1}`} loading="lazy" />
              ))}
            </div>
          </>
        )}

        {/* CTA button (shared) */}
        {cta?.label && (
          <a href={cta.link} className="sl-modal-cta-button" target="_blank" rel="noopener noreferrer" title="Click to learn more about propane for your home">
            {cta.label}
          </a>
        )}
      </div>
    </div>
  );
};

export default SouthernLivingModal;
